import { connect } from 'react-redux';
import {
  hasSubmitFailed,
  hasSubmitSucceeded,
  isDirty,
  isInvalid,
  isPristine,
  isSubmitting,
  isValid,
  reset,
  submit,
  change,
  getFormValues,
} from 'redux-form';

import { FORM } from '../../../formBarbers/barberForm/constants';
import bindActionCreatorsWithArgs from '../helpers/bindActionCreatorsWithArgs';

const withFormState = connect(state => ({
  formValues: getFormValues(FORM)(state),
  dirty: isDirty(FORM)(state),
  pristine: isPristine(FORM)(state),
  valid: isValid(FORM)(state),
  invalid: isInvalid(FORM)(state),
  submitting: isSubmitting(FORM)(state),
  submitSucceeded: hasSubmitSucceeded(FORM)(state),
  submitFailed: hasSubmitFailed(FORM)(state),
}), dispatch => bindActionCreatorsWithArgs({
  reset,
  submit,
  change,
}, dispatch, FORM));

export default withFormState;
